<template>
  <div style="display: contents;">
    <tr>
      <td width="1%">
        <b-iconstack  @click="collapsed = !collapsed"
          v-b-tooltip.hover.left :title=" collapsed ? 'mai putin' :'mai mult'"
          :class="collapsed ? 'text-danger' : ''">
          <b-icon stacked icon="square"></b-icon>
          <b-icon stacked
            :icon="collapsed ? 'dash' : 'plus'"
          />
        </b-iconstack>
      </td>
      <td><a href="#)" @click="$emit('view')" class="text-white border p-1 border-dark bg-dark rounded">{{ booking.id }}</a></td>
      <td>{{ toDate(booking.booking_date, 'DD-MM-YYYY') }}</td>
      <td>
        <span class="text-warning" v-if="booking.status === 'option' "><b>OPT</b></span>
        <span class="text-danger" v-else-if="booking.status === 'cancelled' "><b>CNX</b></span>
        <template v-else>
          <span class="text-success" v-if="booking.supplier_status === 'confirmed'"><b>CONF</b></span>
          <span class="text-info" v-if="booking.supplier_status === 'on_request' "><b>REQ</b></span>
        </template>
      </td>
      <td>{{ booking.client_ref }}</td>
      <td>
        <!-- <b-btn variant="outline-secondary btn-xs" size="sm" @click="$emit('editPassenger')"> -->
          {{ booking.pax }}
          <!-- <b-icon icon="pencil-square" class="ml-2"/> -->
        <!-- </b-btn> -->
      </td>
      <td><b>{{ booking.lead_name }}</b></td>
      <td class="text-primary">{{ booking.gross + booking.tax }} {{ booking.currency}}</td>
      <td class="text-success">{{ booking.paid_amount }} {{ booking.currency}}</td>
      <td class="text-danger">{{ booking.gross + booking.tax - booking.commission - booking.paid_amount }} {{ booking.currency}}</td>
      <td class="text-center"><b>{{ toDate(booking.balance_due_date, 'DD-MM-YYYY') }}</b></td>
    </tr>
    <template v-if="collapsed">
      <PackageItemResult
        v-for="(item, itemIndex) in booking.packages"
        :item="item"
        :booking="booking"
        :key="'item' + itemIndex" />
      <BookingItemResult
        v-for="(item, itemIndex) in booking.items"
        :item="item"
        :booking="booking"
        :key="'item' + itemIndex" />
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import BookingItemResult from './booking_item_result'
import PackageItemResult from './package_item_result'

export default {
  name: 'BookingResult',
  props: ['booking'],
  components: { BookingItemResult, PackageItemResult },
  data () {
    return {
      collapsed: false,
      secondCollapsed: false
    }
  },
  methods: {
    toDate (date, format) {
      return moment.unix(date).format(format)
    }
  }
}
</script>
